// Mirror of backend/python/services/tenants/business_type.py.
// Keep in sync if values change.

export const VOCABULARY_MODES = {
  CUSTOM: 'custom',
  CSI50: 'csi50',
  CSI15: 'csi15',
};

export const BUSINESS_TYPES = [
  {
    id: 'general_contractor',
    label: 'General Contractor',
    description: 'Ground-up construction, multi-trade projects.',
    defaultVocabularyMode: VOCABULARY_MODES.CSI50,
  },
  {
    id: 'electrician',
    label: 'Electrician',
    description: 'Division 26 — wiring, conduit, fixtures, panels.',
    defaultVocabularyMode: VOCABULARY_MODES.CUSTOM,
  },
  {
    id: 'plumber',
    label: 'Plumber',
    description: 'Division 22 — supply, waste, fixtures.',
    defaultVocabularyMode: VOCABULARY_MODES.CUSTOM,
  },
  {
    id: 'hvac',
    label: 'HVAC Contractor',
    description: 'Division 23 — heating, ventilation, air conditioning.',
    defaultVocabularyMode: VOCABULARY_MODES.CUSTOM,
  },
  {
    id: 'painter',
    label: 'Painter',
    description: 'Division 9 — interior and exterior painting.',
    defaultVocabularyMode: VOCABULARY_MODES.CUSTOM,
  },
  {
    id: 'roofer',
    label: 'Roofer',
    description: 'Division 7 — roofing, waterproofing, flashing.',
    defaultVocabularyMode: VOCABULARY_MODES.CUSTOM,
  },
  {
    id: 'concrete',
    label: 'Concrete Contractor',
    description: 'Division 3 — formwork, reinforcement, placement.',
    defaultVocabularyMode: VOCABULARY_MODES.CUSTOM,
  },
  {
    id: 'framing_carpentry',
    label: 'Framing / Carpentry',
    description: 'Division 6 — rough and finish carpentry.',
    defaultVocabularyMode: VOCABULARY_MODES.CUSTOM,
  },
  {
    id: 'flooring',
    label: 'Flooring',
    description: 'Division 9 — tile, hardwood, carpet, resilient.',
    defaultVocabularyMode: VOCABULARY_MODES.CUSTOM,
  },
  {
    id: 'landscaping',
    label: 'Landscaping',
    description: 'Division 32 — planting, irrigation, hardscape.',
    defaultVocabularyMode: VOCABULARY_MODES.CUSTOM,
  },
  {
    id: 'other',
    label: 'Other',
    description: "We'll default to standard CSI 50 — you can change this later in settings.",
    defaultVocabularyMode: VOCABULARY_MODES.CSI50,
  },
];

export function findBusinessType(id) {
  return BUSINESS_TYPES.find((bt) => bt.id === id) || null;
}
